import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';

import viewsRoute from './components/local-brand-views';
import modifierRoute from './components/local-brand-modifiers';
import itemRoute from './components/local-brand-items';
import insightsRoute from './components/local-brand-insights';
import menuOptimizerRoute from './components/local-brand-menu-optimizer';
import updatesRoute from './components/local-brand-updates';
import activityLogRoute from './components/local-brand-activity-log';
import menuworksRoute from './components/local-brand-menuworks';
import { LocalMenuGroupRouteNames, LocalMenuGroupRoutePathNames } from '../../enums';

const Component = () => import('./LocalBrandDetails.vue');

export default {
  path: buildChildURL(
    LocalMenuGroupRoutePathNames.ID,
    LocalMenuGroupRoutePathNames.BRAND_DETAILS,
    LocalMenuGroupRoutePathNames.BRAND_ID,
  ),
  name: LocalMenuGroupRouteNames.BRAND_DETAILS,
  component: Component,
  redirect: { name: LocalMenuGroupRouteNames.BRAND_MENUS },
  children: [
    ...viewsRoute,
    modifierRoute,
    itemRoute,
    insightsRoute,
    menuOptimizerRoute,
    updatesRoute,
    activityLogRoute,
    menuworksRoute,
  ],
} as RouteRecordRaw;
